import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=13e7bb25&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports